import('./bootstrap');
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import './styles/main.scss';

// function SuperAdminApp(props) {
//   return <App />
// }

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <App />
// );

// export default SuperAdminApp